import {inject, Injector} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {NzMessageService} from 'ng-zorro-antd/message';

/**
 * Functional HTTP interceptor that surfaces backend errors via NzMessageService.
 *
 * NzMessageService is resolved lazily through the Injector to avoid the
 * circular-dependency error that bites if it is injected directly at the top
 * of the interceptor (NzMessageService depends on HttpClient transitively).
 */
export const errorInterceptor: HttpInterceptorFn = (request, next) => {
    const injector = inject(Injector);
    let messageService: NzMessageService | null = null;

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (!messageService) {
                messageService = injector.get(NzMessageService);
            }
            const detail = error?.error?.detail;
            const message = typeof detail === 'string' ? detail : detail?.message ?? null;
            if (error.status === 401) {
                messageService.error(message || 'Authentication failed. Please sign in again.');
            } else if (error.status === 400) {
                messageService.error(message || (error.error?.detail ?? 'Bad request'));
            } else if (error.status === 500) {
                messageService.error(message || 'A server error occurred. Please try again later.');
            }
            return throwError(() => error);
        })
    );
};
